import { create, type StateCreator } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import { FILTERS_CUSTOM_COLOR_PICKER } from '~/constants/localStorageKeys';

type CustomHexSlice = {
  hexes: string[];
  setHexes: (hexes: string[]) => void;
  addHex: (hex: string) => void;
  removeHex: (hex: string) => void;
  clearHexes: () => void;
};

type CreateCustomHexSlice = (
  initialState: Pick<CustomHexSlice, 'hexes'>,
) => StateCreator<CustomHexSlice, [], [], CustomHexSlice>;

const createCustomHexSlice: CreateCustomHexSlice = (initialState) => (set) => ({
  hexes: initialState.hexes ?? [],
  setHexes: (hexes: string[]) => set({ hexes }),
  addHex: (hex: string) =>
    set((state) => ({
      hexes: state.hexes.includes(hex) ? state.hexes : [...state.hexes, hex],
    })),
  removeHex: (hex: string) =>
    set((state) => ({
      hexes: state.hexes.filter((h) => h !== hex),
    })),
  clearHexes: () => set({ hexes: [] }),
});

export type CustomColorPickerState = CustomHexSlice;

export const useCustomColorPickerStore = create<CustomColorPickerState>()(
  devtools(
    persist(
      (...args) => ({
        ...createCustomHexSlice({ hexes: [] })(...args),
      }),
      {
        name: FILTERS_CUSTOM_COLOR_PICKER,
        partialize: (state) => ({
          hexes: state.hexes,
        }),
        version: 1,
      },
    ),
  ),
);
